import { render, staticRenderFns } from "./PrincipaisFornecedoresImpo.vue?vue&type=template&id=36324bb5&"
import script from "./PrincipaisFornecedoresImpo.vue?vue&type=script&lang=js&"
export * from "./PrincipaisFornecedoresImpo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports